module.exports = __webpack_public_path__ + "static/spectrum-55910e9067c57438a241150c7f10b541.svg";